import { useCallback, useEffect, useRef, useState } from "react";
import dailyTargetsService from "../api/services/dailyTargetsService";
import { getSupportSocket } from "../api/services/supportSocket";
import { subscribeDailyTargetsChanged } from "../utils/dailyTargetsEvents";

export default function useHeaderDailyTargets(enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const mountedRef = useRef(true);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(false);
    try {
      const res = await dailyTargetsService.getHeaderTargets();
      if (!mountedRef.current) return;
      if (res?.visible || res?.csr || res?.chatSupport) {
        setData({ ...res, visible: true });
      } else if (res) {
        setData(res);
      }
    } catch {
      if (mountedRef.current) setError(true);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    mountedRef.current = true;
    if (!enabled) {
      setData(null);
      setLoading(false);
      return undefined;
    }

    refresh();

    const unsubscribe = subscribeDailyTargetsChanged(() => {
      refresh();
    });

    const socket = getSupportSocket();
    const onSocket = () => refresh();
    socket.on("dailyTargetsChanged", onSocket);

    return () => {
      mountedRef.current = false;
      unsubscribe();
      socket.off("dailyTargetsChanged", onSocket);
    };
  }, [enabled, refresh]);

  return { data, loading, error, refresh };
}
